import { Permission } from "./Permission";

export interface Role {
  id: number;
  name: string;
  description: string;
  tenantID?: number;
  permissions?: Array<Permission>;
}

export enum RoleIDMap {
  SUPER_ADMIN = 1,
  ADMIN = 2,
  DRIVER = 3,
  DISPATCHER = 4,
  PROPERTY_MANAGER = 5,
  YARD_MANAGER = 6,
  SALES = 7,
  ACCOUNTING = 8,
  TOWPAY_MANAGEMENT = 11,
  TOWPAY_ADMIN = 12,
}

export enum RoleTypes {
  SUPER_ADMIN = "Super Admin",
  ADMIN = "Admin",
  DRIVER = "Driver",
  DISPATCHER = "Dispatcher",
  PROPERTY_MANAGER = "Property Manager",
  YARD_MANAGER = "Yard Manager",
  SALES = "Sales",
  ACCOUNTING = "Accounting",
  TOWPAY_MANAGEMENT = "Towpay Management",
  TOWPAY_ADMIN = "Towpay Admin",
}

// Autura staff roles for the TowPay merchant management app. Only super admins see
// them anywhere in the UI, and only user 1 can assign them.
export const TOWPAY_ROLE_IDS: ReadonlyArray<number> = [
  RoleIDMap.TOWPAY_MANAGEMENT,
  RoleIDMap.TOWPAY_ADMIN,
];
export const TOWPAY_ROLE_NAMES: ReadonlyArray<string> = [
  RoleTypes.TOWPAY_MANAGEMENT,
  RoleTypes.TOWPAY_ADMIN,
];

export const ROLES: Array<Role> = [
  {
    id: RoleIDMap.SUPER_ADMIN,
    name: RoleTypes.SUPER_ADMIN,
    description: "Super Admin",
  },
  { id: RoleIDMap.ADMIN, name: RoleTypes.ADMIN, description: "Admin" },
  { id: RoleIDMap.DRIVER, name: RoleTypes.DRIVER, description: "Driver" },
  {
    id: RoleIDMap.DISPATCHER,
    name: RoleTypes.DISPATCHER,
    description: "Dispatcher",
  },
  {
    id: RoleIDMap.PROPERTY_MANAGER,
    name: RoleTypes.PROPERTY_MANAGER,
    description: "Client Login",
  },
  {
    id: RoleIDMap.YARD_MANAGER,
    name: RoleTypes.YARD_MANAGER,
    description: "Yard Manager",
  },
  { id: RoleIDMap.SALES, name: RoleTypes.SALES, description: "Sales" },
  {
    id: RoleIDMap.ACCOUNTING,
    name: RoleTypes.ACCOUNTING,
    description: "Accounting",
  },
  // Autura staff roles for the TowPay merchant management app, not tenant roles.
  // RoleSelect gates both to user 1 only. Roles 9 (Police) and 10 (Autura
  // Engineering) are deliberately still absent: adding them to every tenant's picker
  // is a separate product decision.
  {
    id: RoleIDMap.TOWPAY_MANAGEMENT,
    name: RoleTypes.TOWPAY_MANAGEMENT,
    description: "View TowPay merchants and send invites",
  },
  {
    id: RoleIDMap.TOWPAY_ADMIN,
    name: RoleTypes.TOWPAY_ADMIN,
    description: "Edit and delete TowPay merchants",
  },
];
